var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button-remove") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button-remove",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(7.000000, 7.000000)",
    stroke: "#666666",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 0,
    x2: 0,
    y2: 10,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 10,
    y2: 10,
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonRemove);
export default __webpack_public_path__ + "static/media/button-remove.d7873b5143317d996e0cc3c672be031a.svg";
export { ForwardRef as ReactComponent };